import { getGameCategories } from './api';
import { menuIcon } from './images';

// [{ key, icon }] for every game category; [] on error.
export async function loadGameCategories() {
    try {
        const res = await getGameCategories();
        const categories = res?.data?.data || [];
        return categories.map(cat => ({ key: cat, icon: menuIcon(cat) }));
    } catch (e) {
        return [];
    }
}
